import React, {
  ForwardRefRenderFunction,
  forwardRef,
  useEffect,
  useState,
} from "react";
import { Input } from "sr/helpers";
import { useIntl } from "react-intl";
import * as Yup from "yup";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";

interface Data {
  first_name: string;
  last_name: string;
}

const NameChange: ForwardRefRenderFunction<any, any> = (props, ref) => {
  const intl = useIntl();

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");

  const [errors, setErrors] = useState<any>({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (props?.data) {
      setFirstName(props?.data?.first_name || "");
      setLastName(props?.data?.last_name || "");
    }
  }, [props?.data]);

  const NameChangeSchema = Yup.object({
    first_name: Yup.string()
      .trim()
      .min(2, "INPUT.VALIDATION.FIRSTNAME.MIN")
      .required("INPUT.VALIDATION.FIRSTNAME"),

    last_name: Yup.string()
      .trim()
      .min(2, "INPUT.VALIDATION.LASTNAME.MIN")
      .required("INPUT.VALIDATION.LASTNAME"),
  });

  useEffect(() => {
    props?.HandleData({
      first_name: firstName,
      last_name: lastName,
    });
  }, [firstName, lastName]);

  const validateData = async () => {
    setLoader(true);

    const formData: Data = {
      first_name: firstName,
      last_name: lastName,
    };

    try {
      await NameChangeSchema.validate(formData, { abortEarly: false });

      setErrors({});
      props?.HandleData(formData);

      return true;
    } catch (validationErrors: any) {
      const newErrors: any = {};

      validationErrors.inner?.forEach((error: any) => {
        newErrors[error.path] = error.message;
      });

      setErrors(newErrors);
      return false;
    } finally {
      setLoader(false);
    }
  };

  React.useImperativeHandle(ref, () => ({
    validateData,
  }));

  return (
    <>
      {loader && <LoaderFullScreen />}

      <Input
        label={intl.formatMessage({
          id: "AUTH.INPUT.FIRSTNAME",
          defaultMessage: "First Name",
        })}
        placeholder={intl.formatMessage({
          id: "AUTH.INPUT.FIRSTNAME.PLACEHOLDER",
          defaultMessage: "Enter your first name",
        })}
        type="text"
        value={firstName}
        error={errors?.first_name}
        onChange={(e: any) => setFirstName(e.target.value)}
      />

      <Input
        label={intl.formatMessage({
          id: "AUTH.INPUT.LASTNAME",
          defaultMessage: "Last Name",
        })}
        placeholder={intl.formatMessage({
          id: "AUTH.INPUT.LASTNAME.PLACEHOLDER",
          defaultMessage: "Enter your last name",
        })}
        type="text"
        value={lastName}
        error={errors?.last_name}
        onChange={(e: any) => setLastName(e.target.value)}
      />
    </>
  );
};

export default forwardRef(NameChange);
